//@flow
import { SEARCH_ON_CHANGE, SEARCH_CHANGE_TYPE } from "./constants";

export const onChangeSearch = (payload: string) => {
  return {
    type: SEARCH_ON_CHANGE,
    payload,
  };
};

export const changeSearchType = (payload: string) => {
  return {
    type: SEARCH_CHANGE_TYPE,
    payload,
  };
};
